import { IMerchantSelect } from "../../interfaces/form";
import { ALL_MERCHANTS_OPTION } from "../../utils/constants";
import { GenericAutocomplete } from "../GenericAutocomplete";

const MerchantSelect = ({
  merchants,
  handleChangeValue,
  initialValues,
}: IMerchantSelect) => {
  const parsedMerchants = merchants.map(
    ({
      merchant: {
        id,
        entity: { name },
      },
    }) => ({ id, name })
  );

  return (
    <GenericAutocomplete
      initialValues={initialValues}
      options={parsedMerchants}
      allOption={ALL_MERCHANTS_OPTION}
      handleChangeValue={handleChangeValue}
      label="Merchants"
      fieldKey="merchants"
      noOptionsText="No se encontró el merchant."
    />
  );
};

export default MerchantSelect;
